{
	"title": "Categorieën",
	"description": "Zo deelt de shop het assortiment in, bijvoorbeeld wegwerp, wasbaar, navulling en accessoires. Elke categorie heeft een eigen pagina in de shop.",
	"list": "Categorieën",
	"empty": "Er zijn nog geen categorieën. Maak hieronder de eerste.",
	"orderHint": "De shop toont de categorieën in deze volgorde. Verplaats een categorie met de pijltjes.",
	"column": {
		"position": "Plek",
		"name": "Categorie",
		"products": "Producten",
		"actions": "Acties"
	},
	"productCount_one": "{{count}} product",
	"productCount_other": "{{count}} producten",
	"moveUp": "Omhoog: {{name}}",
	"moveDown": "Omlaag: {{name}}",
	"moved": "{{name}} staat nu op plek {{position}} van {{total}}.",
	"new": {
		"title": "Categorie toevoegen",
		"description": "Een nieuwe categorie komt onderaan de lijst.",
		"submit": "Toevoegen"
	},
	"edit": {
		"button": "Bewerken: {{name}}",
		"title": "{{name}} bewerken",
		"submit": "Opslaan",
		"cancel": "Annuleren"
	},
	"field": {
		"name": "Naam",
		"namePlaceholder": "Bijvoorbeeld Wegwerp",
		"slug": "Slug",
		"slugDescription": "De pagina van de categorie in de shop: /producten/{{slug}}",
		"holder": "Houder",
		"noHolder": "Geen houder",
		"holderDescription": "Met een houder wordt de categorie in de shop een wisserpagina, met het blok \"Wat past\". Zonder houder is het een gewone categoriepagina met filters.",
		"description": "Korte tekst",
		"descriptionDescription": "Staat bovenaan de pagina van de categorie.",
		"seoTitle": "SEO-titel",
		"seoTitleDescription": "Leeg: de shop gebruikt de naam.",
		"seoDescription": "SEO-omschrijving",
		"seoDescriptionDescription": "Leeg: de shop gebruikt het begin van de korte tekst."
	},
	"delete": {
		"button": "Verwijderen: {{name}}",
		"title": "{{name}} verwijderen?",
		"description_one": "De categorie verdwijnt uit de shop, en {{count}} product gaat eruit. Het product zelf blijft. Dit kun je niet ongedaan maken.",
		"description_other": "De categorie verdwijnt uit de shop, en {{count}} producten gaan eruit. De producten zelf blijven. Dit kun je niet ongedaan maken.",
		"confirm": "Verwijderen"
	},
	"error": {
		"slugTaken": "Een andere categorie heeft deze slug al.",
		"notFound": "Deze categorie bestaat niet meer. Laad de pagina opnieuw.",
		"orderOutdated": "De lijst is intussen veranderd. Hij is opnieuw geladen; verplaats de categorie nog eens.",
		"holderNotFound": "Deze houder bestaat niet meer. Kies een andere."
	},
	"path": "/producten/{{slug}}",
	"wisserpagina": "Wisserpagina van {{holder}}",
	"help": {
		"categories": {
			"title": "Categorieën",
			"area": "Producten › Categorieën",
			"short": "Zo deelt de shop het assortiment in, zoals wegwerp, wasbaar en navulling. Elke categorie is een pagina in de shop, met de tegels van zijn producten. De shop toont ze in de volgorde van deze lijst.",
			"warning": "Een categorie is geen optie en geen klantgroep. Met een optie kiest een klant een variant van één product; een klantgroep bepaalt de prijs van een zakelijke klant.",
			"terms": [
				"product:category",
				"category:form",
				"category:slug",
				"category:holderPage",
				"product:options",
				"price:customerGroup"
			]
		},
		"form": {
			"title": "Categorie toevoegen of bewerken",
			"area": "Producten › Categorieën",
			"short": "De naam is de kop van de categoriepagina in de shop, de korte tekst staat eronder. De SEO-titel en -omschrijving ziet een klant in Google; laat je ze leeg, dan neemt de shop de naam en de korte tekst.",
			"terms": ["category:slug", "category:holderPage"]
		},
		"slug": {
			"title": "Slug van een categorie",
			"area": "Producten › Categorieën",
			"short": "Het laatste stuk van het adres van de categoriepagina: cleanbudget.nl/producten/wegwerp. Kleine letters, cijfers en streepjes. Bij een nieuwe categorie volgt hij de naam, tot je hem zelf wijzigt.",
			"warning": "Wijzig je de slug, dan werkt het oude adres niet meer: een link in een mail of bij Google geeft dan een foutpagina."
		},
		"holderPage": {
			"title": "Wisserpagina",
			"area": "Producten › Categorieën",
			"short": "Een categorie met een houder is in de shop een wisserpagina: bovenaan staat Wat past, met de voetmaat en de meettip van die houder. Een klant met die houder ziet daar hoe hij meet en welke navulling past.",
			"terms": ["product:holder", "holder:fitGuide"],
			"goTo": {
				"to": "/product/holder",
				"label": "Naar Houders"
			}
		}
	},
	"helpExample": {
		"tiles": "Voorbeeld uit de shop: de categoriepagina Navulling, met de korte tekst en de producttegels van Floorwipes XXL: pak van 20 voor €8,95, €0,45 per doek, en pak van 100 voor €29,95, €0,30 per doek, Bespaar 33%.",
		"name": "Navulling",
		"description": "Doekjes en navullingen voor je wisser."
	}
}
